import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { X } from 'lucide-react';
import { useCreateLeadMutation } from '../../api/leadsApi';
import { LEAD_SOURCES } from '../../utils/status';
import { applyApiErrorsToForm } from '../../utils/apiError';
import ApiErrorBanner from '../../components/ApiErrorBanner';
import { toast } from 'react-toastify';

export default function AddLeadModal({ onClose }) {
  const { register, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm({
    defaultValues: { source: 'WebsiteForm', priority: 'Warm' },
  });
  const [createLead] = useCreateLeadMutation();
  const [serverError, setServerError] = useState(null);

  const submit = async (data) => {
    setServerError(null);
    try {
      await createLead(data).unwrap();
      toast.success('Lead captured');
      onClose();
    } catch (e) {
      const msg = applyApiErrorsToForm(setError, e);
      setServerError(msg);
      toast.error(msg);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit(submit)}>
          <div className="modal-header">
            <h2>Add Lead</h2>
            <button type="button" className="modal-close" onClick={onClose}><X size={18} /></button>
          </div>
          <div className="modal-body">
            <ApiErrorBanner message={serverError} onDismiss={() => setServerError(null)} />

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Full name *</label>
                <input className="form-control" {...register('fullName', { required: 'Required', maxLength: 128 })} />
                {errors.fullName && <span className="form-field-error">{errors.fullName.message}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Phone *</label>
                <input className="form-control" {...register('phoneNumber', { required: 'Required', maxLength: 32 })} />
                {errors.phoneNumber && <span className="form-field-error">{errors.phoneNumber.message}</span>}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="form-control" type="email" {...register('email')} />
                {errors.email && <span className="form-field-error">{errors.email.message}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">City</label>
                <input className="form-control" {...register('city')} />
                {errors.city && <span className="form-field-error">{errors.city.message}</span>}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Source</label>
                <select className="form-control" {...register('source')}>
                  {LEAD_SOURCES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Priority</label>
                <select className="form-control" {...register('priority')}>
                  <option value="Hot">Hot</option><option value="Warm">Warm</option><option value="Cold">Cold</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Notes</label>
              <textarea className="form-control" rows={3} {...register('notes')} />
              {errors.notes && <span className="form-field-error">{errors.notes.message}</span>}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Saving…' : 'Create Lead'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
